/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { TextField, EventOrUrlField, ContentModuleModal } from '@molecules';
import MediaField from '@organisms/MediaField';
import { useEvent } from '@api/hooks';

import Form from '../Form';

import { FORM_FIELD, FORM_FIELDS } from './constants';
import Item from './Item';

const PastEventResult = ({ visible, onSubmit, hide, previewImg, onDelete, initialValues: data, errors }) => {
  const [form] = Form.useForm(FORM_FIELDS);
  const initialValues = React.useMemo(() => form.deserialize(data), [data, form]);
  const { event, ...eventQuery } = useEvent(data?.eventId);
  const eventOrUrlRef = React.useRef();

  React.useEffect(() => {
    if (visible) {
      form.setFieldsValue(
        event.id ? { [FORM_FIELD.EVENT_URL.entityName]: event } : { [FORM_FIELD.EVENT_URL.urlName]: data?.url },
      );
    }
  }, [form, event, eventQuery.status, visible, data]);

  const handleClose = React.useCallback(() => {
    // eslint-disable-next-line no-unused-expressions
    eventOrUrlRef.current?.reset();
    form.resetFields();
    hide();
  }, [form, hide]);

  const handleFinish = React.useCallback(
    (values) => {
      onSubmit(values);
      handleClose();
    },
    [handleClose, onSubmit],
  );

  return (
    <ContentModuleModal
      visible={visible}
      title="Past event results"
      subtitle="Show the results from a past event"
      okText={onDelete ? 'SAVE CHANGES' : 'ADD PAST EVENT RESULTS'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <Form
        form={form}
        hideRequiredMark
        layout="vertical"
        wrapperCol={{ span: 24 }}
        initialValues={initialValues}
        onSerializedFinish={handleFinish}
      >
        <MediaField {...FORM_FIELD.EVENT_IMAGE} />
        <TextField {...FORM_FIELD.EVENT_TITLE} />
        <EventOrUrlField ref={eventOrUrlRef} {...FORM_FIELD.EVENT_URL} />
      </Form>
    </ContentModuleModal>
  );
};

PastEventResult.Item = Item;

export default PastEventResult;
